import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import fleetBrand from '../../assets/images/logos/FleetWhite.png';
import './forgot.scss';
import useForgottenPassword from '../../api/auth/useForgottenPassword';

export default function Forgot() {
  const [email, setEmail] = useState('');

  const BASE_URL = useSelector((state) => state.BASE_URL);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const { isLoading, isSuccess, passwordForgotten } = useForgottenPassword();

  const sendForgottenPasswordEmail = async (e) => {
    e.preventDefault();

    try {
      await passwordForgotten(email);
    } catch (error) {
      console.error(
        'Une erreur est survenue lors de la réinitialisation de votre mot de passe :',
        error?.message || error
      );
    }
  };

  return (
    <>
      <div className="forgot-container">
        {/* Background image with trucks on road */}
        <div className="background-image"></div>

        {/* Forgot password form */}
        <div className="forgot-content">
          <div className="forgot-card">
            {/* Logo */}
            <div className="logo-container">
              <img src={fleetBrand} alt="Fleet Logo" className="logo" />
            </div>

            {/* Title */}
            <h1 className="forgot-title">Réinitialiser votre mot de passe</h1>
            <p className="forgot-subtitle">
              Saisissez votre adresse email pour recevoir un lien de réinitialisation
            </p>

            {/* Success message */}
            {isSuccess && (
              <div className="success-alert">
                ✓ Un email de réinitialisation a été envoyé à votre adresse
              </div>
            )}

            {/* Forgot form */}
            <Form className="forgot-form" onSubmit={sendForgottenPasswordEmail}>
              <Form.Group className="form-group">
                <Form.Label>Adresse email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="vous@exemple.com"
                  onChange={handleEmailChange}
                  value={email}
                  className="form-input"
                />
              </Form.Group>

              <Button
                type="submit"
                disabled={email === '' || isLoading}
                className="submit-btn"
              >
                {isLoading ? 'Envoi en cours...' : 'Envoyer le lien'}
              </Button>
            </Form>

            {/* Back to login link */}
            <div className="forgot-footer">
              <Link to="/login" className="back-link">
                <FontAwesomeIcon icon={faArrowLeft} />
                <span>Retour à la connexion</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
